import React from "react";
import ReactDOM from "react-dom";
import { ChakraProvider } from "@chakra-ui/react";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import ptBr from "date-fns/locale/pt-BR";
import moment from "moment";
import "moment/locale/pt-br";
import { theme } from "consts";
import App from "./App";
import { initializeApp } from "@firebase/app";
import { firebase } from "_config";
import "./style.css";

registerLocale("pt-br", ptBr);
setDefaultLocale("pt-br");
moment.locale("pt-br");

initializeApp(firebase);

ReactDOM.render(
  <ChakraProvider theme={theme}>
    <App />
  </ChakraProvider>,
  document.getElementById("root")
);
